export default __webpack_public_path__ + "static/media/warehouse-solid.880982b4.svg";